module.exports = __webpack_public_path__ + "static/media/fortalezas_card.c2ecdcad.png";